module.exports = __webpack_public_path__ + "img/Switchingcenterselect.1f5436b6.svg";